/** @jsx jsx */

import React, { Fragment as _, useState, useRef, useEffect } from 'react';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import { connect } from 'react-redux';
import EditMarker from 'components/UI/EditMarker';
import placeholder from 'assets/addImg@3x.svg';
import { colors } from 'styles/variables';
import getBlockById from 'services/apiHelpers/getBlockById';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { EditWrapper0, EditWrapper1 } from './EditWrappers';
// import SVGIcon from 'assets/SVG.svg';
import svgPlaceholder from 'assets/animations/placeholder.js';
import isIE from 'services/isIE';

import ReactBodymovin from 'react-lottie';

const { lPink } = colors;

const frameSelected = keyframes`
  from {
    width: 50%;
    height: 50%;
  }
  to {
    width: 75%;
    height: 75%;
  }
`;

const SVG = ({
  id,
  focusedNodeId,
  src,
  mediaParentId = null,
  editWrapperType = 0,
}) => {
  // const [animationData, setAnimationData] = useState(src);

  let animationData;
  // this : src != undefined seemed to break it ?
  if (src) {
    try {
      animationData = JSON.parse(src);
    } catch {
      animationData = svgPlaceholder;
    }
  } else {
    animationData = svgPlaceholder;
  }

  const selected = focusedNodeId === id;

  const svg = useRef(null);

  const bodymovinOptions = {
    loop: true,
    autoplay: true,
    prerender: true,
    renderer: 'svg',
    animationData,
  };

  const hasAnimationData = Object.keys(animationData).length > 0;

  // console.log({ src, animationData });

  useEffect(() => {
    if (!isIE()) return;
    //
    const svg_ = svg.current.querySelector('svg');

    svg_.removeAttribute('width');
    svg_.removeAttribute('height');

    const onResize = () => {
      svg_.style.width = '100%';
      svg_.style.height = `${window.innerHeight / 2}px`;
    };
    onResize();
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  });

  // useEffect(() => {
  //   setAnimationData({});
  //   //
  //   fetch(src, {
  //     mode: 'no-cors',
  //     headers: {
  //       Accept: 'application/json',
  //     },
  //   })
  //     .then(response => {
  //       if (response.status === 302 || response.status === 301) {
  //         return fetch(response.headers.get('Location'), {
  //           mode: 'no-cors',
  //           headers: {
  //             Accept: 'application/json',
  //           },
  //         });
  //       } else {
  //         return response.json();
  //       }
  //     })
  //     .then(json => {
  //       setAnimationData(json);
  //     });
  // }, [src]);

  //
  // window.console.log(bodymovinOptions);

  const EditWrapper = window.dev()
    ? ({ children }) =>
        editWrapperType === 0 ? (
          <EditWrapper0
            id={id}
            mediaParentId={mediaParentId}
            selected={selected}
          >
            {children}
          </EditWrapper0>
        ) : (
          <EditWrapper1
            id={id}
            mediaParentId={mediaParentId}
            selected={selected}
          >
            {children}
          </EditWrapper1>
        )
    : ({ children }) => <_>{children}</_>;

  return (
    <span
      ref={svg}
      css={css`
        width: 100%;
        height: 100%;
        svg {
          max-height: 50vh !important;
        }
      `}
    >
      <EditWrapper>
        {hasAnimationData ? <ReactBodymovin options={bodymovinOptions} /> : ''}
      </EditWrapper>
    </span>
  );

  return window.dev() ? (
    <div
      css={css`
        position: relative;
        width: 100%;
        height: 100%;
        box-shadow: ${selected ? `0 0 0 1px ${lPink}` : '0 0 0 1px lightGrey'};
        transition: box-shadow 0.2s;
        cursor: pointer;

        &:hover {
          ${!selected && `box-shadow: 0 0 0 1px ${lPink};`}
        }

        * {
          pointer-events: ${selected ? 'auto' : 'none'};
        }

        @media (max-width: 768px) {
          padding: 5px;
        }
      `}
      onClick={e => {
        e.stopPropagation();

        if (selected) return;

        setCurrentBlock({ id });
      }}
    >
      {hasAnimationData ? <ReactBodymovin options={bodymovinOptions} /> : ''}

      {!selected && <EditMarker />}
    </div>
  ) : (
    <_>
      {hasAnimationData ? <ReactBodymovin options={bodymovinOptions} /> : ''}
    </_>
  );
};

export default connect(
  ({ focusedNodeId }: { focusedNodeId: string | number }, { id }: any) => {
    const { src } = getBlockById(id).props;
    return {
      focusedNodeId,
      // ...(focusedNodeId === id && { [Math.random()]: '' }),
      src,
    };
  }
)(SVG);
